// components/support/SupportContainer.jsx
import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { InfoOutlinedIcon, AddIcon } from 'icons/materialIcons';
import WhiteBackgroundContainer from 'components/support/WhiteBackgroundContainer';
import ContactUs from 'components/support/ContactUs';
import SupportArticles from 'components/support/SupportArticles';
import RequestAFeatureModal from 'components/support/RequestAFeatureModal';
import NotificationSnackbar from 'components/common/notification/NotificationSnackbar';
import WhiteButtonWithIcon from 'components/common/button/WhiteButtonWithIcon';
import { useNavigate } from 'react-router-dom';

const SupportContainer = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success'
  });

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleSnackbarClose = () => {
    setSnackbar(prev => ({ ...prev, open: false }));
  };

  const handleSubmitSuccess = () => {
    setSnackbar({
      open: true,
      message: 'Feature request sent successfully!',
      severity: 'success'
    });
  };

  const handleSubmitError = (errorMessage) => {
    setSnackbar({
      open: true,
      message: errorMessage,
      severity: 'error'
    });
  };

  const handleInteractiveOnboarding = () => {
    navigate('/dashboard/mycards');
  };

  return (
    <>
      <Box sx={{ p: 3, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography variant="h6">
          How can we help?
        </Typography>

        <Box sx={{ display: 'flex', gap: 2 }}>
          <WhiteButtonWithIcon
            icon={InfoOutlinedIcon}
            text="Replay Interactive Onboarding"
            onClick={handleInteractiveOnboarding}
          />
          <WhiteButtonWithIcon
            icon={AddIcon}
            text="Request a Feature"
            onClick={handleOpenModal}
          />
        </Box>
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
        }}
      >
        <WhiteBackgroundContainer>
          <ContactUs />
        </WhiteBackgroundContainer>

        {/* SupportArticles - COMMENTED OUT FOR FUTURE IMPLEMENTATION */}
        {/* <WhiteBackgroundContainer>
          <SupportArticles />
        </WhiteBackgroundContainer> */}
      </Box>

      <RequestAFeatureModal
        open={isModalOpen}
        onClose={handleCloseModal}
        onSubmitSuccess={handleSubmitSuccess}
        onSubmitError={handleSubmitError}
      />

      <NotificationSnackbar
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        handleClose={handleSnackbarClose}
      />
    </>
  );
};

export default SupportContainer;